var TabApprovalsEquipmentsCustomFieldsModule = /** @class */ (function () {
    function TabApprovalsEquipmentsCustomFieldsModule() {
    }
    return TabApprovalsEquipmentsCustomFieldsModule;
}());
export { TabApprovalsEquipmentsCustomFieldsModule };
